"use strict";

exports.__esModule = true;
exports.NavbarTitle = NavbarTitle;
exports.TitleWrapper = exports.Title = exports.SubTitle = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _Theme = require("../../../Theme");
var _whenModern = require("../../../Theme/UiDesign/whenModern");
var _excluded = ["title", "subTitle"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var TitleWrapper = exports.TitleWrapper = _styledComponents["default"].div.withConfig({
  displayName: "NavbarTitle__TitleWrapper",
  componentId: "sc-lp2kij-0"
})(["display:flex;flex-direction:column;justify-content:center;"]);
var Title = exports.Title = _styledComponents["default"].h1.withConfig({
  displayName: "NavbarTitle__Title",
  componentId: "sc-lp2kij-1"
})(["color:", ";text-overflow:ellipsis;white-space:nowrap;word-wrap:normal;overflow:hidden;font-family:", ";font-weight:", ";font-size:", ";", " line-height:1.2;padding:0;margin:0;.", " &{color:", ";}"], (0, _Theme.val)("NavbarColor"), (0, _Theme.val)("FontFamilyHeading"), (0, _Theme.val)("NavbarTitleFontWeight"), (0, _Theme.val)("NavbarTitleFontSize"), (0, _whenModern.whenModern)("letter-spacing: -0.01em;"), _core.Classes.DARK, (0, _Theme.val)("NavbarColor"));
var SubTitle = exports.SubTitle = _styledComponents["default"].p.withConfig({
  displayName: "NavbarTitle__SubTitle",
  componentId: "sc-lp2kij-2"
})(["color:", ";font-weight:200;font-size:", ";line-height:1;padding:0;margin:0;.", " &{color:", ";}"], (0, _Theme.val)("NavbarSubTitleColor"), (0, _Theme.val)("fontSizeXS"), _core.Classes.DARK, (0, _Theme.val)("NavbarSubTitleColor"));

/**
 * Displays a navbar title, optionally with subtitle.
 */
function NavbarTitle(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(TitleWrapper, _extends({}, extra, {
    "data-testid": "NavbarTitle"
  }), subTitle && title !== subTitle && /*#__PURE__*/_react["default"].createElement(SubTitle, {
    key: "subheader",
    "data-testid": "NavbarTitle.SubTitle"
  }, subTitle), /*#__PURE__*/_react["default"].createElement(Title, {
    key: "navbar",
    "data-testid": "NavbarTitle.Title"
  }, title));
}